import { useMemo } from 'react';
import { useCookies } from 'react-cookie';

export const useLoginState = () => {
  const [cookie] = useCookies<string, { [key: string]: string }>(['sid']);
  const loggedIn = useMemo(() => !!cookie?.sid, [cookie?.sid]);

  return { loggedIn };
};
